import { GeneralSelectionStore } from '@stores/SelectionStore'
import React, { Context } from 'react'

export const SelectionContext: Context<{ selectionStore: GeneralSelectionStore }> =
  React.createContext({
    selectionStore: null
  })
